<section id="content" class="measurement" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang?.measurementTools}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li> {{lang?.measurementTools}}</li>
            <!-- <a [routerLink]="'/'+AppFrontRoutes.MEASURMENT">{{lang?.measurementTools}}</a> -->          
          <!-- <li>
            <a [routerLink]="'/'+AppFrontRoutes.MEASURMENT">{{ lang?.listofmeasurementTools }}</a>
          </li> -->
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" class="active"><a href="#listTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{ lang?.list }}</a></li>
                  <li role="presentation"><a href="#maintenanceTab" aria-controls="maintenanceTab" role="tab"
                      data-toggle="tab">{{lang?.calibration_planning}}</a></li>
                </ul>
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-2" >
                        <div class="social-icons">


                          <a [routerLink]="['/'+AppFrontRoutes.CREATE]" class="plus-add"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>


                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div class="col-sm-2" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.type_of_calibration" [data]="dropdownList"
                          [(ngModel)]="filter1" [settings]="dropdownSettings" (onSelect)="datatableFilterAction($event)"
                          (onDeSelect)="datatableFilterAction()" (onSelectAll)="onSelectAll($event)">
                        </ng-multiselect-dropdown>
                      </div>

                      <div class="col-sm-2" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.responsible" [data]="dropdownList1"
                          [(ngModel)]="filter2" [settings]="dropdownSettings1"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="onSelectAll($event)">
                        </ng-multiselect-dropdown>
                      </div>

                      <div class="col-sm-2" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="lang?.calibrationStatus" [data]="dropdownList2"
                          [(ngModel)]="filter3" [settings]="dropdownSettings2"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="onSelectAll($event)">
                        </ng-multiselect-dropdown>
                      </div>

                      <div  class="col-sm-2">
                        <input
                        #search
                        id="measureSearch"
                        type="text"
                        class="form-control"
                        [placeholder]="lang?.search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                        

                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="records">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang.no }}</th>
                            <th>{{ lang.description }}</th>
                            <th>{{ lang.brand }}</th>
                            <th>{{ lang.model }}</th>
                            <th>{{ lang.dateofpurchase }}</th>
                            <th>{{ lang.internalCode }}</th>
                            <th>{{ lang.serialNumber }}</th>
                            <th>{{ lang.location }}</th>
                            <th style="display:none">{{ lang.documentAttachment }}</th>
                            <th>{{ lang.measuringRange }}</th>
                            <th>{{ lang.resolution }}</th>
                            <th>{{ lang.maxallowedError }}</th>
                            <th>{{ lang.activeCalibrationplans }}</th>
                            <th>{{ lang.calibrationStatus }}</th>
                            <th>{{ lang.typeofCalibration }}</th>
                            <th>{{ lang.instrumentStatus }}</th>
                            <th>{{ lang.responsible }}</th>
                            <th>{{ lang.photo }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of records let i = index" id="{{record.measurementId}}">
                            <td>{{ i + 1 }}</td>
                           <td></td>
                           <td>{{ i + 1  }}</td>
                           <td><a [routerLink]="['/'+AppFrontRoutes.SINGLE_VIEW+'/'+record.measurementId]"
                            class="blue_action">{{record.measurement_discrp}}</a></td>
                           <td>{{ record.measurement_brand }}</td>
                           <td>{{ record.measurement_model }}</td>
                           <td>{{ record.measurement_doc1 }}</td>
                           <td>{{ record.internal_code }}</td>
                           <td>{{ record.badge_no }}</td>
                           <td>{{ record.measurement_location }}</td>
                           <td style="display:none"><a href="{{ record.doc_url }}">{{ record.doc_result }}</a></td>
                           <td>{{ record.measuring_range }}</td>
                           <td>{{ record.precision_degree }}</td>
                           <td>{{ record.measurement_uncertainty }}</td>
                           <td>{{ record.arr1 }}</td>
                           <td><div [innerHTML]="record.arr2"></div></td>
                           <td>{{ record.calstatus }}</td>
                           <td><div [innerHTML]="record.istatus"></div></td>
                           <td>{{ record.config_employees }}</td>
                           <td><img src="{{record.measurement_image1}}" style="width: 50px; height: 50px;"></td>
                           <td>
                            <div class="btn-group dropup">

                              <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                              <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.measurementId)"><i
                                      class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="duplicate(record.measurementId)"><i
                                      class="fa fa-clone"></i> {{ lang.duplicate }}</a></li>
                                <!-- <li><a class="blue_action"><i class="fa fa-edit"></i> {{ lang.modify }}</a></li> -->

                                <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a [routerLink]="['/'+AppFrontRoutes.EDIT+'/'+record.measurementId]" class="edit_action"><i
                                      class="fa fa-edit"></i> {{ lang.modify }}</a></li>


                                <!-- <li><a class="blue_action"><i class="fa fa-eye"></i> {{ lang.view }}</a></li> -->
                                <li><a [routerLink]="['/'+AppFrontRoutes.SINGLE_VIEW+'/'+record.measurementId]"
                                    class="view_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.view}}</a>
                                </li>
                              </ul>
                            </div>
                          </td>
                         </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane" id="maintenanceTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">


                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport3"
                            data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                          
                          <a class="plus-delete" *ngIf="deleteOption" (click)="cmultiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        #search
                        style="float: right;width: 20%;"
                        id="calibrationSearch"
                        type="text"
                        class="form-control"
                        [placeholder]="lang?.search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                             
                     </div>

                      

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover" id="table2" *ngIf="result">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang?.no }}</th>
                            <th>{{lang?.instruction_desc}}</th>
                            <th>{{lang?.internalCode}}</th>
                            <th>{{lang?.serialNumber}}</th>
                            <th>{{lang?.brand}}</th>
                            <th>{{lang?.model}}</th>
                            <th>{{lang?.plan_code}}</th>
                            <th>{{ lang?.plan_desc }}</th>
                            <th>{{lang?.execution_date}}</th>
                            <th>{{lang?.days_left}}</th>
                            <th>{{lang?.action}}</th>
                          </tr>
                        </thead>
                        <tbody dragula="result" [(dragulaModel)]="result">
                          <tr *ngFor="let resval of result let i = index" id="{{ resval.ordinaryId }}" style="color: red;">
                             <td>{{ i + 1 }}</td>
                            <td></td>
                            <td>{{ i + 1  }}</td>
                            <td>{{ resval.measurement_discrp }}</td>
                            <td>{{ resval.internal_code }}</td>
                            <td>{{ resval.badge_no }}</td>
                            <td>{{ resval.measurement_brand }}</td>
                            <td>{{ resval.measurement_model }}</td>
                            <td>{{ resval.plan_code }}</td>
                            <td>{{ resval.plan_description }}</td>
                            <td>{{ resval.date_exe }}</td>
                            <td>{{ resval.dstr }}</td>
                            <td>
                              <div class="btn-group dropup">
                                 <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                   data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>
                                 <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                   <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="blue_action"
                                       (click)="addMeasurement(resval.ordinaryId,resval.service_id,resval.plans_id)"><i
                                         class="fa fa-clone"></i>INSERT MAINTENANCE</a></li>
                                 </ul>
                               </div>
                            </td>
                          </tr>
                         </tbody>

                      </table>
                    </div>
                  </div>

                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">IMPORT MEASURMENT TOOLS DATA</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_measurement.csv" download="">Click here</a> to download to csv format file</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns {{ mLang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> Select All{{ mLang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns {{ mLang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>